import React from "react";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "antd";
import googleApp from "../assets/images/google-app.svg";
import appleApp from "../assets/images/apple-app.svg";
import { FaArrowRight } from "react-icons/fa";
import { LiaCarSideSolid } from "react-icons/lia";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import { MdOutlineEmail } from "react-icons/md";
import { FaFacebookF, FaTwitter, FaInstagram } from "react-icons/fa";
import { TfiTwitterAlt } from "react-icons/tfi";
import { SiInstagram } from "react-icons/si";
import logo from "../assets/images/msm-motors-logo.png";
const Footer = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-[#13141a] pt-20 pb-4">
      <div className="w-[86%] m-auto border-b border-gray-800 pb-4">
        <div className="mb-10">
          <Row>
            <Col lg={5}>
              <p className="text-[20px] font-[700] text-white mb-8">
                About Company
              </p>
              <div className="text-[#b3b3b3] text-[15px] font-[600]">
                <p className="mb-4 group relative hover:cursor-pointer">
                  About Us{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p className="mb-4 group relative hover:cursor-pointer">
                  Return & Exchange{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p className="mb-4 group relative hover:cursor-pointer">
                  Refund Policy{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p className="mb-4 group relative hover:cursor-pointer">
                  Reviews{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p className="mb-4 group relative hover:cursor-pointer">
                  FAQ's{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p className="mb-4 group relative hover:cursor-pointer">
                  Contact Us{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
              </div>
            </Col>
            <Col lg={5}>
              <p className="text-[20px] font-[700] text-white mb-8">
                Search & Explore
              </p>
              <div className="text-[#b3b3b3] text-[15px] font-[600]">
                <p
                  onClick={() =>
                    navigate("/car-listing-left-sidebar", {
                      state: {
                        category_id: "1",
                      },
                    })
                  }
                  className="mb-4 group relative hover:cursor-pointer"
                >
                  Used Cars{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p
                  onClick={() =>
                    navigate("/car-listing-left-sidebar", {
                      state: {
                        category_id: "2",
                      },
                    })
                  }
                  className="mb-4 group relative hover:cursor-pointer"
                >
                  New Cars{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p className="mb-4 group relative hover:cursor-pointer">
                  Auction Cars{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p className="mb-4 group relative hover:cursor-pointer">
                  Sell My Car{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p className="mb-4 group relative hover:cursor-pointer">
                  Shop Now{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
              </div>
            </Col>
            <Col lg={5}>
              <p className="text-[20px] font-[700] text-white mb-8">
                Car By Brands
              </p>
              <div className="text-[#b3b3b3] text-[15px] font-[600]">
                <p
                  onClick={() => navigate("/single-brand-category")}
                  className="mb-4 group relative hover:cursor-pointer"
                >
                  Toyota{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p
                  onClick={() => navigate("/single-brand-category")}
                  className="mb-4 group relative hover:cursor-pointer"
                >
                  BMW{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p
                  onClick={() => navigate("/single-brand-category")}
                  className="mb-4 group relative hover:cursor-pointer"
                >
                  Chevrolet{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p
                  onClick={() => navigate("/single-brand-category")}
                  className="mb-4 group relative hover:cursor-pointer"
                >
                  Hyundai{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p
                  onClick={() => navigate("/single-brand-category")}
                  className="mb-4 group relative hover:cursor-pointer"
                >
                  Mercedes-Benz{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p
                  onClick={() => navigate("/single-brand-category")}
                  className="mb-4 group relative hover:cursor-pointer"
                >
                  Jeep{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p
                  onClick={() => navigate("/single-brand-category")}
                  className="mb-4 group relative hover:cursor-pointer"
                >
                  Suzuki{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p
                  onClick={() => navigate("/single-brand-category")}
                  className="mb-4 group relative hover:cursor-pointer"
                >
                  Tesla{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p
                  onClick={() => navigate("/single-brand-category")}
                  className="mb-4 group relative hover:cursor-pointer"
                >
                  Mazda{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
              </div>
            </Col>
            <Col lg={5}>
              <p className="text-[20px] font-[700] text-white mb-8">
                Car By Location
              </p>
              <div className="text-[#b3b3b3] text-[15px] font-[600]">
                <p className="mb-4 group relative hover:cursor-pointer">
                  Karachi{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p className="mb-4 group relative hover:cursor-pointer">
                  Islamabad{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p className="mb-4 group relative hover:cursor-pointer">
                  Lahore{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p className="mb-4 group relative hover:cursor-pointer">
                  Peshawar{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p className="mb-4 group relative hover:cursor-pointer">
                  Bannu{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
                <p className="mb-4 group relative hover:cursor-pointer">
                  DI Khan{" "}
                  <FaArrowRight className="hidden group-hover:inline-block group-hover:text-customGreen" />
                </p>
              </div>
            </Col>
            <Col xs={24} lg={4}>
              <p className="text-[20px] font-[700] text-white mb-8">
                Download App
              </p>
              <div className="text-[#b3b3b3] text-[15px] font-[600] flex gap-2 md:block">
                <div
                  className="text-center px-3 py-3 rounded rounded-[6px] mb-8 h-[74px]"
                  style={{ border: "1px solid hsla(0,0%,100%,.1)" }}
                >
                  <img className="m-auto" src={googleApp} alt="" />
                </div>
                <div
                  className="text-center px-3 py-3 rounded rounded-[6px] h-[74px]"
                  style={{ border: "1px solid hsla(0,0%,100%,.1)" }}
                >
                  <img className="m-auto" src={appleApp} alt="" />
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <Row>
          <Col xs={24} lg={6}>
            <div
              className={`flex items-center  gap-3 text-white
                `}
            >
              {/* <LiaCarSideSolid className="text-[83px] mt-3" /> */}

              {/* <div className="block">
                  <p className="text-[38px] font-bold">MSM</p>
                  <p className="text-customGreen mt-[-8px] italic">
                    {" "}
                    MOTORS CAR DEALER
                  </p>
                </div> */}
              <img width="130px" className="m-auto" src={logo} alt="" />
            </div>
          </Col>
          <Col xs={24} md={12} lg={6}>
            <div className="flex items-center justify-center md:justify-[unset] gap-2 mt-6">
              <PhoneInTalkIcon
                className="text-customGreen"
                style={{ fontSize: "35px" }}
              />
              <div className="border-s-2 border-gray-600 ps-2">
                <p className="font-medium text-[14px] md:text-[15px] text-gray-400">
                  To More Inquiry
                </p>
                <p className="font-semibold text-customGreen text-[16px] md:text-[20px]">
                  +923315806780
                </p>
              </div>
            </div>
          </Col>
          <Col xs={24} md={12} lg={6}>
            <div className="flex items-center justify-center md:justify-[unset] gap-2 mt-6">
              <MdOutlineEmail
                className="text-customGreen"
                style={{ fontSize: "35px" }}
              />
              <div className="border-s-2 border-gray-600 ps-2">
                <p className="font-medium text-[15px] text-gray-400">
                  To Send Mail
                </p>
                <p className="font-semibold text-customGreen text-[16px] lg:text-[20px]">
                  help.msmmotor@gmail.com
                </p>
              </div>
            </div>
          </Col>
          {/* <Col xs={12} lg={3}>
            <p className="font-medium text-[15px] text-gray-400 mt-8 text-center">
              Advertise With Us
            </p>
          </Col>
          <Col xs={12} lg={3}>
            <p className="font-medium text-[15px] text-gray-400 mt-8 text-center">
              Our Sitemap
            </p>
          </Col> */}
        </Row>
      </div>
      <div className="block md:flex justify-between items-center w-[86%] m-auto mt-8">
        <p className="mb-4 md:mb-[unset] font-[400] text-[14px] md:text-[15px] text-gray-200">
          Copyright 2024 <span className="text-customGreen"> MSM Motor </span>{" "}
          | All Rights <span className="text-customGreen">Reserved</span>
        </p>
        <p onClick={()=>navigate("/terms-and-policy")} className="mb-4 md:mb-[unset] text-center md:text-start font-[400] text-[14px] md:text-[15px] text-gray-200 cursor-pointer hover hover:text-customGreen">
          Privacy Policy
        </p>
        
        <div className="flex items-center justify-center md:justify-[unset] gap-4">
          <p className="font-[400] text-[15px] text-gray-200 ">
            Follow MSM Motor
          </p>
          <a
            href="https://www.facebook.com/share/fPo1Bc7pDFKcmKA4/?mibextid=qi2Omg"
            target="_"
          >
            <p className="w-[25px] h-[25px] rounded-[100%] flex justify-center items-center border border-gray-600 p-2 cursor-pointer">
              <FaFacebookF className="text-customGreen" />
            </p>
          </a>

          <p className="w-[25px] h-[25px] rounded-[100%] flex justify-center items-center border border-gray-600 p-[5px] cursor-pointer">
            <TfiTwitterAlt className="text-customGreen text-[40px]" />
          </p>
          <a href=" https://www.instagram.com/msmmotorofficial?igsh=YzljYTk1ODg3Zg=="
          target="_">
            <p className="w-[25px] h-[25px] rounded-[100%] flex justify-center items-center border border-gray-600 p-[6px] cursor-pointer">
              <SiInstagram className="text-customGreen" />
            </p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
